/**
 * media-gallery
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_media-gallery.twig';
import './_media-gallery.css';

// Media gallery uses slick slider for the desktop and mobile displays.
require('slick-carousel');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

export const name = 'media-gallery';

export const defaults = {
  dummyClass: 'js-media-gallery-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { mediaGallery = {} }) {
  // Find our component within the DOM
  // eslint-disable-next-line no-undef
  const mediaGalleries = once(
    'media-gallery--init',
    '.media-gallery',
    $context
  );
  // Bail if component does not exist
  if (!mediaGalleries.length) {
    return;
  }

  const $mediaGallery = $(mediaGalleries);

  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...mediaGallery,
  };

  // An example of what could be done with this component
  $mediaGallery.addClass(settings.dummyClass);

  $mediaGallery.each(function initializeMediaGallery() {
    const localId = Math.ceil(Math.random() * 10000);
    const localIdMain = `media-gallery__viewer-${localId}-main`;
    const localIdItems = `media-gallery__viewer-${localId}-items`;
    $('.media-gallery__viewer', this)
      .attr('id', localIdMain)
      .slick({
        asNavFor: `#${localIdItems}`,
        arrows: true,
        infinite: false,
      });
    $('.media-gallery__items', this)
      .attr('id', localIdItems)
      .slick({
        asNavFor: `#${localIdMain}`,
        dots: false,
        focusOnSelect: true,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
  });

  // Refreshes the slider on page load.
  $(window).on('load', function refreshSliders() {
    $('.media-gallery__items').slick('slickSetOption', true);
  });
}

export default enable;
